<script>
import { Bar } from "vue-chartjs/legacy";
import { getStyle, hexToRgba } from "@coreui/coreui/dist/js/coreui-utilities";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
import { random } from "@/shared/utils";
import moment from "moment";

export default {
  extends: Bar,
  props: ["height", "chartdata"],
  mounted() {
    const brandSuccess = getStyle("--success") || "#4dbd74";
    const brandInfo = getStyle("--info") || "#20a8d8";
    const brandDanger = getStyle("--danger") || "#f86c6b";

    let elements = 27;
    const data1 = [];
    const data2 = [];
    const data3 = [];

    // for (let i = 0; i <= elements; i++) {
    //   // data1.push(random(50, 200))
    //   // data2.push(random(80, 100))
    //   // data3.push(65)
    // }
    /// asdf
    let labels = [];
    let date = moment();
    labels.push(date.format("DD/MM/YYYY"));
    for (let i = 1; i <= 6; i++) {
      labels.push(date.subtract(1, "days").format("DD/MM/YYYY"));
    }
    labels.reverse();
    this.renderChart(
      {
        labels: labels,
        datasets: [
          {
            label: "Sales",
            backgroundColor: hexToRgba(brandInfo, 10),
            borderColor: brandInfo,
            pointHoverBackgroundColor: "#fff",
            borderWidth: 2,
            data: this.chartdata,
          },
          {
            label: "My Second dataset",
            backgroundColor: "transparent",
            borderColor: brandSuccess,
            pointHoverBackgroundColor: "#fff",
            borderWidth: 2,
            data: data2,
          },
          {
            label: "My Third dataset",
            backgroundColor: "transparent",
            borderColor: brandDanger,
            pointHoverBackgroundColor: "#fff",
            borderWidth: 1,
            borderDash: [8, 5],
            data: data3,
          },
        ],
      },
      {
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: "index",
          position: "nearest",
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return {
                backgroundColor:
                  chart.data.datasets[tooltipItem.datasetIndex].borderColor,
              };
            },
          },
        },
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                stepSize: Math.ceil(250 / 5),
                max: 250,
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3,
          },
        },
      }
    );
  },
};
// moment now
// arr.push(moment.format())
/**
 * for...
 *   arr.push(moment.sub(i+1,'days').format())
 *
 */
</script>